import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./state/store";
import axios from "axios";

// UI e Animações
import AOS from 'aos';
import 'aos/dist/aos.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import VueTheMask from 'vue-the-mask';
import VueFeather from 'vue-feather';
import AppHero from '@/components/mirai/AppHero.vue';
import { instalarAntiPreenchimento } from '@/helpers/mirai/antiPreenchimento';
import 'bootstrap/dist/js/bootstrap.bundle';

// Estilos
import '@/assets/scss/config/saas/app.scss';
import '@/assets/scss/mermaid.min.css';

// I18n
import i18n from './i18n';

// Importação dos Estados Globais (Criados no passo anterior)
import {
    grupoState,
    localidadesState,
    categoriasState,
    tagsState
} from './state/globalData';

import './registerServiceWorker'

// Configuração do AOS
AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

axios.defaults.baseURL = process.env.VUE_APP_APIURL;
axios.defaults.withCredentials = true;
if (process.env.NODE_ENV !== "production") {
    axios.defaults.headers.common["X-Auth-Context"] = "cau";
}

// Configuração do Toast
const toastOptions = {
    position: 'top-left',
    timeout: 10000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: true,
    closeButton: 'button',
    icon: true,
    rtl: false
};

// Criação da App
const app = createApp(App);

// Plugins
app.use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .use(VueTheMask)
    .use(i18n)
    .use(Toast, toastOptions)
    .use(vClickOutside);

// Componentes Globais
app.component(VueFeather.type, VueFeather);
app.component("AppHero", AppHero);

// Configuração de Propriedades Globais
app.config.globalProperties.$mirai = {};

// Conectando os estados reativos globais (Vindo do arquivo separado)
// Assim seus componentes continuam acessando this.$grupo.data, etc.
app.config.globalProperties.$grupo = grupoState;
app.config.globalProperties.$localidades = localidadesState;
app.config.globalProperties.$categorias = categoriasState;
app.config.globalProperties.$tags = tagsState;

// Lógica do Chat (Mantida vinculada ao Store)
app.config.globalProperties.$chat = {
    get visible() {
        return store.getters['chat/isChatVisible'];
    },
    get status(){
        return store.getters['chat/chatStatus'];
    },
    show() {
        store.dispatch('chat/changeVisibility', { isVisible: true });
    },
    hide() {
        store.dispatch('chat/changeVisibility', { isVisible: false });
    },
    changeStatus(value){
        store.dispatch('chat/changeStatus', { status: value });
    }
};

// Configurações Finais
app.config.warnHandler = () => {};
app.config.productionTip = false;

// Montagem
app.mount('#app');

// Impede o navegador/extensões de senha de injetarem login ou e-mail salvos nos
// campos de busca e filtro (ver helpers/mirai/antiPreenchimento.js).
instalarAntiPreenchimento();

// Service Worker
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js")
            .then((registration) => {
                console.debug("✅ Service Worker registrado:", registration);
            })
            .catch((error) => {
                console.error("❌ Falha no Service Worker:", error);
            });
    });
}
